import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator' ;
import {namespace} from 'vuex-class';
import * as moment from 'moment' ;
import {
  DOCUMENT_MODULE_NAMESPACE,
  DOCUMENT_SET_DOCUMENT_PARAMETER,
  DOCUMENT_GET_DOCUMENTS_ATTACHMENTS,
  DOCUMENT_SET_DOCUMENTS_PAGINATION,
  DOCUMENT_LOADERS,
  DOCUMENT_INIT_DOCUMENT_SELECTION,
  DOCUMENT_SET_DOCUMENT_SELECTION,
  DOCUMENT_SET_DOCUMENT_ACTION,
  DOCUMENT_REMOVE_DOCUMENT,
  DOCUMENT_EDIT_DOCUMENT,
  DOCUMENT_RESET_DOCUMENT, DOCUMENT_SET_DOCUMENTS, DOCUMENT_SET_LOADER_STATE, DOCUMENT_GET_DOCUMENT_TYPES
} from '../../../../store/document';
import {
  IDocumentListingViewmodel,
  IDocumentParamter,
  IDocumentTypeListingViewmodel
} from '../../../../models/documents' ;
import {CrudStatus} from '../../../../common/enums';
import {AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_FUNCTIONALITIES} from '../../../../store/authorization';
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store';
import {IUserDetails} from '../../../../models/user';
import {IFile} from '../../../../components/attachment-manager';
import {IDocument} from '../../../../models/documents/document';
import { eventBus } from '../../../../main';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../../store/service-book';
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store';

const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({
  components: {
    'item-condition': async () => import('../document-item-conditions/DocumentItemConditions.vue'),
    'document-table-loader': async () => import('../../../profile/loaders/profile-pagination-loader/ProfilePaginationLoader.vue'),
    'document-delete-loader': async () => import('../../../profile/loaders/profile-delete-loader/ProfileDeleteLoader.vue')
  },
  filters: {
    date_format(date: string) {
      return moment(date).format("DD/MM/YYYY")
    },
    attachment_type(name: string) {
      if (!name) return ''
      const res = name.split('.')
      if (res && res[res.length-1]) return res[res.length-1]
      return ''
    }
  }
})
class DocumentAttachmentList extends Vue {

  dtIsLoading: boolean
  dtHoveredMember: number
  dtMessageErrorModel: boolean
  dtError: any
  dtIsEmptyTypesFilter: boolean
  dtDocMenu: {
    active: boolean,
    x: number,
    y: number,
    item: any
  }
  dtAttributeItem: number
  newPagination: {page:number,rowsPerPage:number}
  paginationLoading : boolean


  readonly LOADING_TABLE: {}[] = Array.from(new Array(4)).map(item => ({}))

  constructor() {
    super()
    this.dtHoveredMember = -1
    this.dtIsLoading = false
    this.dtMessageErrorModel = false
    this.dtError = null
    this.dtIsEmptyTypesFilter = false
    this.dtDocMenu = {
      active: false,
      x: 0,
      y: 0,
      item: null
    }
    this.dtAttributeItem = -1
    this.newPagination = {
      page: 1,
      rowsPerPage: 10
    }
    this.paginationLoading = false
  }


  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>
  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails


  @DocumentStore.Getter documentParameter: IDocumentParamter;
  @DocumentStore.Getter documentTypes: any[]
  @DocumentStore.Getter documents: IDocumentListingViewmodel[]
  @DocumentStore.Getter pagination: { page: number, total_pages: number }
  @DocumentStore.Getter loaders: Map<string, boolean>
  @DocumentStore.Getter documentCrudActionStatus: CrudStatus
  @DocumentStore.Getter documentSelection: number[]
  @UserStore.Getter userInfo: IUserDetails

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENTS_ATTACHMENTS)
  storeGetDocumentAttachments: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_REMOVE_DOCUMENT)
  storeRemoveDocument: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_EDIT_DOCUMENT)
  storeEditDocument: (id: number) => void

  @DocumentStore.Action(DOCUMENT_RESET_DOCUMENT)
  storeResetDocument: (payload?: IDocument) => void

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName?: string) => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (payload: IDocumentParamter) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENTS_PAGINATION)
  storeSetDocumentPagination: (payload?: any) => void

  @DocumentStore.Mutation(DOCUMENT_INIT_DOCUMENT_SELECTION)
  storeInitDocumentSelection: () => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_SELECTION)
  storeSetDocumentSelection: (id: number) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_ACTION)
  storeSetDocumentAction: (status: CrudStatus) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENTS)
  storeSetDocumentsList: (documents: IDocumentListingViewmodel[]) => void

  @DocumentStore.Mutation(DOCUMENT_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean}) => void

  @DocumentStore.Mutation(DOCUMENT_GET_DOCUMENT_TYPES)
  storeSetDocumentTypes: (documents: IDocumentTypeListingViewmodel[]) => void


  get lblSetting() {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/document').default
    }
  }

  get documentType() {
    var {fk_attachment_type} = this.documentParameter
    return this.documentTypes.find(documentType => documentType.fk_attachment_type === fk_attachment_type[0])
  }

  get coHeaders() {
    return [
      {
        //text: 'avatar',
        value: 'avatar',
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.document_headers.filename),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.document_headers.addedAt),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.document_headers.addedBy),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        value: 'modifier & supprimer',
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title hidden'
      }
    ]
  }

  get coDocuments() {
    return !this.coTableLoader ? this.documents : this.LOADING_TABLE
  }

  get coTableLoader() {
    return this.loaders.get(DOCUMENT_LOADERS.TABLE_LOADER)
  }

  get coTotalPages() {
    return this.pagination.total_pages
  }

  get coCurrentPage() {
    return this.pagination.page
  }

  set coCurrentPage(page: number) {

    this.storeSetDocumentPagination({page})

    if ((this.$route.name === 'block_documents') && !this.documentParameter.fk_attachment_type.length) {
      this.storeSetDocumentParameter({detail: 'true'})
      this.storeGetDocumentAttachments().finally(() => {})
    }
    else if (this.$route.name === 'service_book_details' && !this.documentParameter.fk_attachment_type.length)
    {
      this.storeSetDocumentParameter({detail: 'true'})
      if(!this.currentServiceBook.apartment)
      {
        this.storeGetServiceBook(this.$route.params.id).then(()=>{
          this.storeSetDocumentParameter({
            block:[parseInt(this.currentServiceBook.apartment.fk_apartment_block)],
            apartment:[this.currentServiceBook.apartment.id]
          })
          this.storeGetDocumentAttachments().finally(() => {})
        })
      } else {
        this.storeSetDocumentParameter({
          block:[parseInt(this.currentServiceBook.apartment.fk_apartment_block)],
          apartment:[this.currentServiceBook.apartment.id]
        })
        this.storeGetDocumentAttachments().finally(() => {})
      }
    }
  }

  get isOpenDeleteMessage() {
    return this.documentCrudActionStatus === CrudStatus.Delete
  }

  get coDocumentDelectionMessage() {
    if (this.documentSelection.length === 1)
      return this.$t(this.lblSetting.documentDeleteMessage, {name: (this.documents.find(document => document.id === this.documentSelection[0]) as any).name})
    else if (this.documentSelection.length > 1) return this.$t(this.lblSetting.documentDeleteSelectionMessage)
    return ""
  }

  get layoutPadding() {
    return this.$vuetify.breakpoint.lgAndDown ? 'px-0' : 'px-3'
  }

  created() {
    this.storeGetFunctionalities('document_management')
      .then(response => {
        if (this.$route.meta) Object.keys(response).forEach(key => this.$route.meta[key] = true)
      })
  }

  canManageDocument(entity_id): boolean {
    return this.userInfo.id === entity_id || this.$route.meta['manage_agency_document']
  }

  getShareInfo(id): string {
    if (this.coTableLoader) return ''
    const link = (this.documents.find(doc => doc.id === id) as any).link
    return `mailto:${this.userInfo.email}?body=${link}`
  }

  handleShareDoc () {
    if (this.dtDocMenu.item) {
      let url = `mailto:${this.userInfo.email}?body=${this.dtDocMenu.item.link}`
      window.open(url, '_blank').focus();
    }
  }

  handleShowMenu (e, item) {
    // e.preventDefault()
    this.dtDocMenu.x = e.clientX
    this.dtDocMenu.y = e.clientY
    this.$nextTick(() => {
      this.dtDocMenu.active = true
      this.dtDocMenu.item = item
    })
  }

  handleShowMore (e, item) {
    if (this.dtAttributeItem === item.id)
      this.dtAttributeItem = -1
    else this.dtAttributeItem = item.id
  }

  handleDeleteSelection() {
    if (this.documentSelection.length) this.storeSetDocumentAction(CrudStatus.Delete)
  }

  handleAvatarClick(id: number, entity_id: number) {
    if (this.canManageDocument(entity_id))
      this.storeSetDocumentSelection(id)
  }

  isDocumentSelected(id: number): boolean {
    return this.documentSelection.indexOf(id) !== -1
  }

  handleDeleteDocument(id: number) {
    this.storeInitDocumentSelection()
    this.storeSetDocumentSelection(id)
    this.storeSetDocumentAction(CrudStatus.Delete)
  }

  handleDeleteDocumentOK() {
    this.dtIsLoading = true
    let newDocuments = this.documents.map(x => {
      return {...x}
    })
    let idxDocs = []
    this.documentSelection.map(x => {
      idxDocs.push(newDocuments.findIndex(y => y.id === x))
    })
    idxDocs.sort().reverse()
    // for doc types
    let newTypes = this.documentTypes.map(x => {
      return {...x}
    })
    let docToDelete = newDocuments.find(x => x.id === this.documentSelection[0]) as any
    let idxType = newTypes.findIndex(x => x.fk_attachment_type === docToDelete.fk_attachment_type)
    this.storeRemoveDocument()
      .then(response => {
        eventBus.$emit('RELOAD_BLOCK_DASHBORD',this.$route.params.id)
        idxDocs.map(x => {
          newDocuments.splice(x, 1)
          // change number of total document in type doc
          /* if (newTypes[idxType].totalDocuments && newTypes[idxType].totalDocuments > 0){
            newTypes[idxType].totalDocuments -= 1
          } */

        })
        this.storeSetDocumentsList(newDocuments)
        this.storeSetDocumentTypes(newTypes)
      })
      .catch(err => {
        this.dtMessageErrorModel = true
        this.dtError = err
      })
      .finally(() => {
        this.dtIsLoading = false
        this.storeSetLoaderState({ key: DOCUMENT_LOADERS.TABLE_LOADER, value: false })
      })
  }

  handleDeleteDocumentCancel() {
    this.storeInitDocumentSelection()
    this.storeSetDocumentAction(CrudStatus.NoAction)
  }

  handleEditDocument(id: number) {
    this.storeEditDocument(id)
  }

  handleCloseErrorModal() {
    this.dtMessageErrorModel = false
    this.dtError = null
  }

  handleViewDocument(e: Event, link: string) {
    e.preventDefault()
    if (link) window.open(link)
  }

  handleClickDoc(item) {
    console.log('Click Doc', item)
    window.open(item.link)
    // this.$router.push({path: `${this.$route.params.id}/detail/${item.id}`})
  }

  handleUploadFiles(files: IFile[]) {
    this.storeResetDocument({
      attachments: files,
      ...this.documentParameter.fk_attachment_type
      && this.documentParameter.fk_attachment_type.length === 1 && {type: this.documentParameter.fk_attachment_type[0]},
      ...this.documentParameter.block && {blocks: this.documentParameter.block}
    })
    this.storeSetDocumentAction(CrudStatus.Create)
  }

  handleLoadedTypes() {
    this.storeSetDocumentParameter(
      {
        // ...this.$route.name === 'block_documents' && {fk_attachment_type: this.documentTypes.map(docType => docType.fk_attachment_type)},
        apartment: [],
        creator: [],
        $limit: 10,
        detail: undefined
      }
    )

    if (this.$route.name === 'block_documents') this.storeSetDocumentParameter({block: [parseInt(this.$route.params.id)], detail: 'true'} )
    this.storeGetDocumentAttachments()
      .then(res => {})
      .catch(err => {
        console.log('error', err)
      })
      .finally(() => {
        if (this.$route.name === 'block_documents') this.storeSetDocumentParameter({fk_attachment_type: []})
      })
  }

  @Watch('$route.params.id', {immediate: true, deep: true})
  onChange(newVal) {
    if (newVal) {
      this.coCurrentPage = 1;
    }
  }

  @Watch('newPagination',{deep:true})
  paginationHandler(val:{page:number,rowsPerPage:number})
  {
    this.paginationLoading = true
    this.storeSetDocumentParameter({$limit:val.rowsPerPage})
    this.storeSetDocumentPagination({page:val.page})
    this.storeGetDocumentAttachments()
    .finally(() => {
      this.paginationLoading = false
    })
  }
}

export default DocumentAttachmentList




// WEBPACK FOOTER //
// ./src/containers/documents/components/document-attachments/index.ts